var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h1',{staticClass:"text-h4"},[_vm._v(_vm._s(_vm.report.tariffHandle))])]),_c('v-card-text',[_c('key-value-block',{attrs:{"values":_vm.basicData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }